// extracted by mini-css-extract-plugin
module.exports = {"sectionBubble":"Home_sectionBubble__2crHw","probTitle":"Home_probTitle__aygg7"};